import { render, staticRenderFns } from "./SearchHeader.vue?vue&type=template&id=97b96e7e&scoped=true&"
import script from "./SearchHeader.vue?vue&type=script&lang=js&"
export * from "./SearchHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchHeader.vue?vue&type=style&index=0&id=97b96e7e&scoped=true&lang=css&"
import style1 from "./SearchHeader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b96e7e",
  null
  
)

export default component.exports